<template>
<div id="page-carga_ds">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>

            <v-flex xs12>
                <base-material-card color="secondary" icon="library_books" title="Cargar Inventario Inicial" class="elevation-1 px-5 py-3">

                    <v-card-text>
                        <upload-txt postURL="guardar_inventario_inicial" successMessagePath="" errorMessagePath=""></upload-txt>
                    
                       
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>

    </v-container>
</div>
</template>

<script>

import UploadTxt from '@/components/UploadINI.vue'
export default {
    components: {
        UploadTxt
        },
    created: function () {
        this.cliente = this.$local_storage.get("id_cliente");
        //this.model.cliente = 52;  

    },
    data() {
        return {
           
            fab: false,
            mostrarEncabezados: false,
            modalEncabezados: false,
            show_loading: false,
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Informes TXT",
                    disabled: true,
                    href: ""
                },
                {
                    text: "Inventario Inicial",
                    disabled: true,
                    href: ""
                }
            ],
            title: "",
            modal: false,
            update: false,

            file: "",
            cliente: "",
            name_file: "",
            size_file: 0,
            type_file: 'application/zip',
            archivo_original: "",

            rules: {
                required: v => !!v || "Este campo es requerido",
            },
            search: "",

        };
    },

    methods: {

      

      
    }
};
</script>

<style scoped>
.archivoNegrita {
    color: black !important;
    font-weight: bold !important;
    font-size: 15px;
}
</style>
